// Standard HubSpot object types and their objectTypeIds. Callers reference
// fields by object type + property name instead of raw ids, so a form spanning
// multiple objects (e.g. Contact + Company) is unambiguous. IDs are stable
// across HubSpot; custom objects are addressed by passing their raw id
// ('2-7381234') as the key.
export const PORTAL_FORM_OBJECT_TYPES = {
  CONTACT: '0-1',
  COMPANY: '0-2',
  DEAL: '0-3',
  TICKET: '0-5'
};

// Nested prefill map keyed by object type, then by property name. Known object
// types (CONTACT, COMPANY, …) are suggested by the type; a raw objectTypeId
// string (e.g. '2-7381234') is also accepted for custom objects.
// Map a known object-type name to its id; pass through a raw id unchanged.
function toObjectTypeId(objectType) {
  var _objectType;
  return (_objectType = PORTAL_FORM_OBJECT_TYPES[objectType]) !== null && _objectType !== void 0 ? _objectType : objectType;
}

// Build the v2 full property reference ('{objectTypeId}/{property}', e.g.
// '0-1/email') from an object type (name or raw id) and property name.
export function toFieldReference(objectType, property) {
  return `${toObjectTypeId(objectType)}/${property}`;
}

// Apply a nested prefill map to either form version once the form is ready.
// v2 keys fields by the full reference ('0-1/email'); we build it from the
// declared object type and only set fields that actually exist on the form
// (setFieldValue throws synchronously for an unknown reference). v1 is legacy
// and Contact-centric — it keys by bare property name and has no object-type
// concept, so only CONTACT properties are honored there.
export async function applyPrefill(instance, prefill) {
  if (instance.version === 1) {
    var _prefill$CONTACT;
    const contactProps = (_prefill$CONTACT = prefill.CONTACT) !== null && _prefill$CONTACT !== void 0 ? _prefill$CONTACT : {};
    for (const [property, value] of Object.entries(contactProps)) {
      if (instance.hasField(property)) {
        instance.setFieldValue(property, value);
      }
    }
    return;
  }
  const pairs = await instance.getFormFieldValues();
  const availableRefs = new Set(pairs.map(pair => pair.name));
  for (const [objectType, props] of Object.entries(prefill)) {
    if (!props) continue;
    for (const [property, value] of Object.entries(props)) {
      const ref = toFieldReference(objectType, property);
      if (availableRefs.has(ref)) {
        instance.setFieldValue(ref, value);
      }
    }
  }
}